import client from 'shared/ApiClient';
import { RecruitNotification, RecruitNotificationPage } from 'recruit/models';

export async function getRecruitNotifications(page = 1): Promise<RecruitNotificationPage> {
    return client(`recruit/notifications/?page=${page}`);
}

export async function markRecruitNotificationRead(notification: RecruitNotification): Promise<{ updated: number }> {
    return client(`recruit/notifications/${notification.id}/mark-read/`, { body: {} });
}

export async function markAllRecruitNotificationsRead(): Promise<{ updated: number }> {
    return client('recruit/notifications/mark-all-read/', { body: {} });
}
